import { capitalize, styled } from '@mui/material';

import { shouldForwardProp } from '../../../../../utils/shouldForwardProp';
import { Scroller } from '../../../../scroller';
import { PreviewYamlProps } from '../../types';

export const StyledScroller = styled(Scroller, {
  name: 'DsPreviewYaml',
  slot: 'Scroller',
  target: 'DsPreviewYaml-Scroller os-theme-light',
  shouldForwardProp,
  overridesResolver: (_, styles) => styles.scroller,
})<{ ownerState: PreviewYamlProps }>({});

export const SyntaxHighlight = styled('div', {
  name: 'DsPreviewYaml',
  slot: 'SyntaxHighlight',
  target: 'DsPreviewYaml-SyntaxHighlight',
  shouldForwardProp,
  overridesResolver: ({ ownerState }, styles) => [
    styles.syntaxHighlight,
    styles[`size${capitalize(ownerState.size)}`],
  ],
})<{ ownerState: PreviewYamlProps & { errorMarker?: string } }>({});
